import React,{useState} from 'react'
import {SlideProductItem} from '../../styles/Slide' 
import NumberFormat from 'react-number-format';
import { toast } from 'react-toastify';

import { useSelector,useDispatch } from 'react-redux';

import { setBasket } from '../stores/Cart';

import { useCartRequests } from '../../helpers/CartRequests';

import { useHistory } from 'react-router-dom';
import { Currency } from 'react-intl-number-format/dist/index.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Badge from '@mui/material/Badge';
import { Sentry } from "react-activity";

import { faPlus, faShoppingCart, faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { useProductRequests } from '../../helpers/ProductRequests';
import { ProductItem, ProductList } from '../../styles/Product';
import Variant from '../../views/Variant';

export default function SlideProduct({item}) {

  const {addCart,getCart} = useCartRequests()

  const history=  useHistory()

  const {login} = useSelector(state => state.auth)
  
  const {basket} = useSelector(state => state.cart)

  const dispatch=useDispatch()

  const getBasket=()=>{
    getCart().then(res=>{
      dispatch(setBasket(res.data.cart))
    })
  }
  const addToBasket=async(e)=>{
    e.stopPropagation()

    if(login==true){
      const loader=toast.loading('Ürün Sepete Ekleniyor...',{position:toast.POSITION.BOTTOM_RIGHT,isLoading: true,closeOnClick: false,pauseOnHover: false,pauseOnFocusLoss: false,draggable: false})
      addCart([{id:item.id,count:1}]).then(res=>{
        getBasket()
        toast.update(loader, { render: res.data.message, type: "success", isLoading: false, autoClose: 3000,hideProgressBar: false,closeOnClick: true,pauseOnHover: true,pauseOnFocusLoss: false,draggable: true });
      })
      .catch(err=>{
        toast.update(loader, { render: err.response.data.data.message, type: "error", isLoading: false, autoClose: 3000,hideProgressBar: false,closeOnClick: true,pauseOnHover: true,pauseOnFocusLoss: false,draggable: true });
      })
    
    }else{
      history.push('/giris-yap')
    }
  }
  
  const [popupOpen, setPopupOpen] = useState(false);
  const [variants, setVariants] = useState(null);
  const { getProducts } = useProductRequests();

  React.useEffect(() => {
    if(popupOpen && variants==null){
      //setVariants(item.variants)
      getProducts({
        count: 100,
        variantsOfCode: true,
        productCode: item.code,
        page: 1,
        sort:"DATE",
        sortedBy:"DESC"
      })
      .then(async (response) => {
        try {
          setVariants(response.data.data.items);
        } catch (error) {
          setVariants([])
        }
      })
      .catch((err) => {
        setVariants([]);
      });
    }
  }, [popupOpen]);
  


  return (
    <SlideProductItem key={item.id} slider={true} group={item.group}>
      <div
        className="popup"
        // onClick={() => setPopupOpen(false)}
        style={{
          transform: popupOpen != null && popupOpen ? "scale(1)" : "scale(0)",
          opacity: popupOpen != null && popupOpen ? 1 : 0,
        }}
      >
        <div className="box" onClick={(e) => e.stopPropagation()}>
          <div className="close" onClick={() => setPopupOpen(false)}>
            x
          </div>
          <div onClick={(e) => e.stopPropagation()} className="list">
            {popupOpen != null && popupOpen && (
              <Variant onClick={(e) => e.stopPropagation()} slug={item.code} />
            )}
          </div>
        </div>
      </div>
      <div className={"in-stock " + item.stockText}>
        {" "}
        {item.stockText.toUpperCase()}{" "}
      </div>
      <div className="image-box">
        <img
          onContextMenu={() => false}
          onClick={() => history.push("/urun/" + item.slug)}
          src={
            item.image == null
              ? "https://propertywiselaunceston.com.au/wp-content/themes/property-wise/images/no-image@2x.png"
              : item.image
          }
          alt={item.title}
        />
      </div>
      {item.variantCount > 0 ? (
        <div
          className="variant-list"
          onClick={
            () => setPopupOpen(true)
            // history.push("/varyant/" + item.code.replace(".", "-"))
          }
        >
          <div className="colors">
            <div></div>
            <div></div>
          </div>
          <div>{item.variantCount}</div>
        </div>
      ) : (
        <></>
      )}
      <h3> {item.title} </h3>
      {basket != null &&
      basket.find((sub) => sub.productId == item.id) != undefined ? (
        <div className="product-count">
          <div
            style={{
              color: "#ff9f43",
              paddingTop: 10,
              fontSize: 15,
              paddingBottom: 10,
              background: "#fff",
              borderRadius: 1000,
              fontWeight: "bold",
            }}
          >
            <FontAwesomeIcon
              icon={faShoppingCart}
              style={{ marginRight: 0, fontSize: 30 }}
            />
            <span
              style={{
                position: "absolute",
                right: -7,
                top: 10,
                paddingLeft: 5,
                paddingRight: 5,
                borderRadius: 1000,
                color: "#fff",
                background: "red",
              }}
            >
              {basket.find((sub) => sub.productId == item.id).quantity}
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
      {localStorage.getItem("conteynertoken") != null ? (
        <div className="action">
          {item.listPrice != item.salePrice ? (
            <div className="price list-price">
              {/* <h5> <Currency>0</Currency> </h5> */}
              <div>
                {" "}
                <Currency>{item.listPrice}</Currency>{" "}
              </div>
            </div>
          ) : (
            <></>
          )}
          <div className="price">
            {/* <h5> <Currency>0</Currency> </h5> */}
            <div>
              {" "}
              <Currency>{item.salePrice}</Currency> + KDV
            </div>
          </div>
          <div className="basket">
            <button onClick={(e) => addToBasket(e)}>
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: 10 }} />
              Sepete Ekle
            </button>
          </div>
        </div>
      ) : (
        <div
          onClick={() => history.push("/giris-yap")}
          style={{ fontSize: 12, textAlign: "center" }}
        >
          Fiyatları görmek için <strong>giriş</strong> yapın
        </div>
      )}
    </SlideProductItem>
  );
}
